import BrandLogo from '@components/v2/ui/BrandLogo/BrandLogo';
import TeceoLogo from '@components/v2/ui/TeceoLogo/TeceoLogo';
import { Box } from '@mui/material';
import LangEnum from '../../../../../../lang/LangEnum';
import { useApplicationContext } from '../../../../../../modules/context/ApplicationContext/ApplicationContext';
import { getBrandInfo } from '../../../../../../modules/context/ApplicationContext/applicationContext.utils';
import { useTranslation } from '../../../../../../modules/translation/TranslationContext';
import { BrandLogos } from '../../../../../../services/modules/brand/brand.types';
import { useAppEnvironmentStore } from '../../../../../../stores/AppEnvironment/appEnvironment.store';
import { selectIsInStoreEnvironment } from '../../../../../../stores/AppEnvironment/appEnvironment.store.selectors';
import useNavigationLogoClick from './hooks/useNavigationLogoClick';

const SIZES = {
  width: 112,
  height: 24,
};

const INERT_STYLES = {
  cursor: 'default',
  pointerEvents: 'none',
} as const;

interface NavigationLogoProps {
  brand?: {
    name: string;
    logoUrl?: string;
    logos?: BrandLogos;
  };
  onClick?: () => void;
}

const NavigationLogo = ({ brand, onClick }: NavigationLogoProps) => {
  const { state } = useApplicationContext();
  const { translate } = useTranslation();
  const isInStoreEnvironment = useAppEnvironmentStore(selectIsInStoreEnvironment);
  const { navigateOnLogoClick, isLogoNavigationAllowed } = useNavigationLogoClick(onClick);

  const contextBrand = state.brand ?? state.user?.brand;
  const { name: entityName, logoUrl } = brand ?? getBrandInfo(contextBrand);
  const logos = brand?.logos ?? contextBrand?.logos;

  const ariaLabel = translate(
    isInStoreEnvironment ? LangEnum.MAIN_DRAWER_HOME : LangEnum.MAIN_DRAWER_SHOWROOM,
  );

  return (
    <Box
      component="button"
      type="button"
      aria-label={ariaLabel}
      aria-disabled={!isLogoNavigationAllowed}
      onClick={navigateOnLogoClick}
      sx={{
        display: 'flex',
        alignItems: 'center',
        padding: 0,
        border: 'none',
        background: 'none',
        cursor: 'pointer',
        ...(isLogoNavigationAllowed ? {} : INERT_STYLES),
      }}
    >
      {isInStoreEnvironment ? (
        <Box sx={{ maxWidth: SIZES.width }}>
          <TeceoLogo width={SIZES.width} />
        </Box>
      ) : (
        <BrandLogo
          name={entityName}
          logos={{ ...logos, squaredLogo: logoUrl }}
          maxWidth={SIZES.width}
          maxHeight={SIZES.height}
          showNameWithoutImage
        />
      )}
    </Box>
  );
};

export default NavigationLogo;
